import { z } from 'zod';

// Onboarding step 1 — Your Details.
// Matches auth-frontend OnboardingDetailsPage: firstName + lastName + workspaceName
// all collected together, stored in Zustand, sent atomically on the final screen.
export const yourDetailsSchema = z.object({
  firstName: z.string().min(1, 'First name is required').max(100),
  lastName: z.string().min(1, 'Last name is required').max(100),
  workspaceName: z.string().min(1, 'Organization name is required').max(200),
});

export type YourDetailsInput = z.infer<typeof yourDetailsSchema>;

// Onboarding step 2 — About Your Workspace.
// Optional analytics fields only (industry + team size).
// 60–70% fill rate gives valid GTM signal; skip is always valid.
export const workspaceInfoSchema = z.object({
  industry: z.string().max(100).optional(),
  teamSize: z.string().max(32).optional(),
});

export type WorkspaceInfoInput = z.infer<typeof workspaceInfoSchema>;
